import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPost, operationsClient } from '@/lib/api';
import { timeEntryEndpoints } from '@/lib/api/endpoints';
import { timeEntryKeys } from '@/lib/queryKeys';
import type { TimeEntry } from '@/types/timeEntry';

export function useClockOut(appointmentId: string, jobId?: string) {
  const queryClient = useQueryClient();
  return useApiMutation<TimeEntry, string>({
    mutationFn: (entryId) =>
      apiPost<TimeEntry, Record<string, never>>(
        operationsClient,
        timeEntryEndpoints.clockOut(entryId),
        {},
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: timeEntryKeys.appointment(appointmentId),
      });
      if (jobId) {
        void queryClient.invalidateQueries({ queryKey: timeEntryKeys.jobRollup(jobId) });
      }
      toast.success('Clocked out');
    },
  });
}
